export default __webpack_public_path__ + "static/media/README.7bc8dc22.md";